import { render, staticRenderFns } from "./IntegrationMetrics.vue?vue&type=template&id=70b9380c&scoped=true&"
import script from "./IntegrationMetrics.vue?vue&type=script&lang=js&"
export * from "./IntegrationMetrics.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationMetrics.vue?vue&type=style&index=0&id=70b9380c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b9380c",
  null
  
)

export default component.exports